import Weather from "./Weather";

function App() {
  return (
    <div className="App container">
      <Weather defaultCity="New York" />
    </div>
  );
}

export default App;
